<script setup>
import { ref, onMounted, watch, defineExpose, reactive, defineProps, defineEmits, inject, computed } from "vue"
import { permission } from '@/utils/permission';
import i18n from "@/i18n"
import PreviewImg from "@/components/common/PreviewImg";
import { useRouter, useRoute } from "vue-router";
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import useMessage from "@/utils/hooks/useMessage" //信息hooks
import Swal from "sweetalert2";
import { deleteProduct, getFileUrl, copyProduct, getProductsListV3 } from "@/service"
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
const props = defineProps({
    showSearch: {
        type: Boolean,
        default: false,
    },
})
const emits = defineEmits(['updateTabData'])
const tableInfo = ref([])
const fileList = ref([])
const router = useRouter()
const route = useRoute()
const loading = ref(false)
const checkedAll = ref(false) // 全选
// const showCharts = ref([true, true, true])
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const table_head = ref([
    { label: getLangValue('product-management', "title"), width: '9%', sortable: true },
    { label: getLangValue('my.product-line', "table_header1"), width: '9%', },
    { label: getLangValue('product-template', "publicType"), width: '9%', },
    { label: getLangValue('product-management', "status"), width: '9%', },
    { label: getLangValue('product-template', "color"), width: '9%', },
    { label: getLangValue('product-template', "inventory"), width: '9%', },
    { label: getLangValue('product-template', "price"), width: '9%', },
    { label: getLangValue('product-template', "type"), width: '9%', },
    { label: getLangValue('product-template', "size"), width: '9%', },
    { label: getLangValue('product-management', "code_pid_gtin"), width: '9%', },
    { label: getLangValue("base.operation"), width: '9%', },
])
const pageSizeOption = [10, 20, 30, 40, 50]
const statusList = [
    { label: getLangValue("business-product", "tab1"), value: 0 },
    { label: getLangValue("business-product", "tab2"), value: 3 },
    { label: getLangValue("business-product", "testedSuccessfully"), value: 1 },
    { label: getLangValue("business-product", "certificationPassed"), value: 2 },
    { label: getLangValue("business-product", "updatedHSCode"), value: 4 },
    { label: getLangValue("business-product", "updatedTemplate"), value: 5 },
]
const { total, currentPage, pageSize, pageOption } = usetablePageNation()
const { alertInfo, openAlert, formValidataAlert } = useMessage()
const selectedInfo = inject('selectedInfo') //表格选中的产品
// const templateName = ref("")
const searchInfo = reactive({
    keyword: '',  //产品名称
    publicType: '', //公开类型
    status: '', //状态
    hscode: '', //hscode
    hscode_id: '', //hscode_id
    price: [], //价格
    inventory: [], //库存
    hand: [], //手感
    skin: [], //肤感
    heat: [],//热湿舒适度
    aesthetic_comfort: [],
    table_name: '',
    product_template_name: '',
    production_line_name: '',
    productType: '', //产品类型
    hand_feeling_layer: '', //结构层
    template_status: '', // 模板禁用状态
    order_by: 'desc', //排序字段
})
const username = computed(() => {
    let user = sessionStorage.getItem('set_menu_list')
    if (user) {
        user = JSON.parse(user)
        return user.username
    }
    return ''
})
// const switchChange = (info) => {
//     //切换开关
//     console.log(info);
// }
// const getTemplateMenu = async () => {
//     const resp = await getProductTemplateMenu();
//     if (resp) {
//         // templateMenuList.value = resp.payload
//         // 获取type信息
//         if (route.params.id) {
//             const arr = resp.payload.filter(item => item.id == route.params.id)
//             if (arr.length) {
//                 searchInfo.table_name = arr[0].table_name
//                 // getDataList();
//             }
//         }
//     }
// }
// const getTableName = () => {
//     const arr = templateMenuList.value.filter(item => item.id == route.query.tid)
//     if (arr.length) {
//         searchInfo.table_name = arr[0].table_name
//         getDataList();
//     }
// }
const handler = (type, info) => {
    //按钮处理
    let url;
    switch (type) {
        case 'view':
            url = router.resolve({
                path: '/products_info', query: {
                    tid: route.params.id,
                    id: info.id,
                    d_id: info.database_id,
                    t_name: info.organization.table_name,
                    origin: 'productsList'
                }
            }).href
            window.open(url, '_blank')
            break;
        case 'edit':
            url = router.resolve({
                name: 'products_detail', query: {
                    type: 'edit',
                    id: info.id,
                    // d_id: info.database_id,
                    tid: info.database_id,
                    h_id: info.production_line?.database_template?.hscode?.id,
                    t_name: info.organization.table_name,
                    origin: 'productsList',
                    from: window.location.href, // 从哪里来的
                }
            }).href;
            window.open(url, '_blank')
            break;
        case 'delete':
            deleteData(info)
            break;
        case 'copy':
            copyData(info)
            break;
    }
}

const copyData = async (info) => {
    // const { database_id, organization } = info;
    const { id } = info;
    // const name = info['name']
    Swal.fire({
        title: getLangValue("base.copy_alert_title"),
        text: getLangValue('product-management', "message8"),
        icon: "info",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            //延迟2s操作
            // let resp = await copyProduct({ table_name: organization.table_name, database_id: database_id });
            let resp = await copyProduct({ id: id });
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.copy_success"),
                });
                //  更新
                getDataList();
            }
        }
    });
}

const deleteData = async (info) => {
    // const { database_id } = info;
    // const name = info.product_info.children[0].children[0].value
    const name = info['name']
    Swal.fire({
        title: getLangValue("base.delete_alert_title") + `${i18n.global.locale == 'ch' ? name + '?' : ''}`,
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            // console.log(id)
            //延迟2s操作
            // let resp = await deleteProduct(info.table_name, database_id);
            let resp = await deleteProduct(info.id);
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.delete_success"),
                });
                //  更新
                getDataList();
            }
        }
    });
}


const getDataList = async () => {
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        product_name: searchInfo.keyword,
        role_key: searchInfo.productType,
        // production_line_id: route.query.p_id ? route.query.p_id : '',
        is_public: '',
        public_type: searchInfo.publicType,
        status: searchInfo.status,
        production_line_name: searchInfo.production_line_name,
        hand_feeling_layer: searchInfo.hand_feeling_layer,
        template_status: searchInfo.template_status, // 模板禁用状态
        order_by: searchInfo.order_by, //排序字段
        sort_field: 'name', //排序字段
    }
    // if (!params.table_name) return
    // console.log(props.showSearch)
    if (props.showSearch) {
        params.hscode = searchInfo.hscode
        params.hscode_id = searchInfo.hscode_id
        params.price = JSON.stringify(searchInfo.price)
        params.inventory = JSON.stringify(searchInfo.inventory)
        params.hand_feeling = searchInfo.hand.length ? JSON.stringify(searchInfo.hand) : '[]'
        params.skin_feeling = searchInfo.skin.length ? JSON.stringify(searchInfo.skin) : '[]'
        params.heat_and_humidity_comfort = searchInfo.heat.length ? JSON.stringify(searchInfo.heat) : '[]'
        params.aesthetic_comfort = searchInfo.aesthetic_comfort.length ? JSON.stringify(searchInfo.aesthetic_comfort) : '[]'

    }
    loading.value = true
    const resp = await getProductsListV3(params)
    loading.value = false
    if (resp.code == 0) {
        if (resp.payload.total == (currentPage.value - 1) * pageSize.value && currentPage.value > 1) {
            currentPage.value--
            return
        }
        tableInfo.value = resp.payload.data;
        tableInfo.value.forEach(async item => {
            if (item.pid) {
                const reps = await makeQrCode({ type: 2, id: item.id })
                if (reps) {
                    item.qrcodeImgUrl = reps
                }
            }
        })
        // 需要根据筛选项公开类型选择使用哪个数据
        // 不公开 1
        // 仅对供应链公开 3 
        // 完全公开 2
        // if (searchInfo.publicType == '') {
        //     total.value = resp.payload.all_total
        // } else if (searchInfo.publicType == 1) {
        //     total.value = resp.payload.private_total
        // } else if (searchInfo.publicType == 2) {
        //     total.value = resp.payload.public_total
        // } else {
        //     total.value = resp.payload.supply_chain_public_total
        // }
        total.value = resp.payload.total
        emits('updateTabData', resp.payload)
    } else {
        openAlert({
            variant: "danger",
            content: resp.message,
        });
    }

}

const goDetail = (info) => {
    // router.push({ path: '/products_info', query: { tid: route.params.id, id: info.database_id, t_name: info.table_name } })
    if (!permission('product-management.show')) {
        return false
    }

    let url = router.resolve({
        path: '/products_info', query: {
            tid: route.params.id,
            id: info.id,
            d_id: info.database_id,
            t_name: info.organization.table_name,
            origin: 'productsList'
        }
    }).href
    window.open(url, '_blank')
}
// const checkCharts = () => {
//     let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
//     let arr = data.filter(item => item.table_name === route.query.t_name)
//     if (arr.length) {
//         showCharts.value[0] = arr[0].enable_search_hand_feel
//         showCharts.value[1] = arr[0].enable_search_skin_feel
//         showCharts.value[2] = arr[0].enable_search_humidity_heat_comfort
//     }
// }

const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

const getStatus = (status, public_type) => {
    // 完全公开的数据才会有审核转状态
    if (public_type == 2) {
        return statusList.filter(item => item.value == status)[0].label
    }
    return '-'
    // return statusList[Math.floor(Math.random() * 4)].label
}

const getPublic = (type) => {
    let data = [
        {
            label: getLangValue('product-management', "completelypublic"),
            value: 2
        },

        {
            label: getLangValue('product-management', "Opasc"),
            value: 3
        },
        {
            label: getLangValue('product-management', "notpublic"),
            value: 1
        },
    ]
    if (data.length) {
        let arr = data.filter(item => item.value === type)
        if (arr.length) {
            return arr[0].label
        }
    }
    return ''
}


const changCheckBox = (id) => {
    // 选择当前数据 只能选一条
    // tableInfo.value.forEach(item => {
    //     if (item.id == id) {
    //         if(typeof item.checked == 'undefined') {
    //             item.checked = true
    //         }else{
    //             item.checked =!item.checked
    //         }
    //     } else {
    //         item.checked = false
    //     }
    // })
    let arr = tableInfo.value.filter(item => item.checked)
    if (arr.length > 1) {
        // 只保留当前id
        tableInfo.value.forEach(item => {
            item.checked = false
        })
        tableInfo.value.find(item => item.id == id).checked = true
    }
    let obj = tableInfo.value.find(item => item.checked)
    selectedInfo.value = obj ? obj : { hide: true }; // hide 用于关闭对比图表
    // console.log(selectedInfo.value);
}

const toggletAll = () => {
    // 全选或反选
    tableInfo.value.forEach(item => {
        if (checkedAll.value) {
            item.checked1 = true
        } else {
            item.checked1 = false
        }
    })
}

const sort = () => {
    // 处理现在表格的数据
    let dom = document.querySelector('.sortable')
    let classList = dom.classList
    if (classList.value.includes('desc')) {
        // 现在是倒叙 变为升序
        classList.remove('desc')
        classList.add('asc')
       searchInfo.order_by = 'asc'
    } else {
        // 现在是升序 变为降序
        classList.remove('asc')
        classList.add('desc')
       searchInfo.order_by = 'desc'
    }
}

const getName = (name) => {
    // 处理产品名称 如果里面有复制 如果是中文则不管 如果是英文则全部替换为copy
    const productName = name == null ? '' : String(name)
    if (productName.includes('复制') && i18n.global.locale == 'en') {
        return productName.replaceAll('复制', 'copy')
    }
    return productName
}

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList()
})

watch(tableInfo, () => {
    fileList.value = []
    let imageList = tableInfo.value.filter(item => item['picture'].length > 0).map((item) => item['picture'][0])
    // 重复图片 去重
    imageList = [...new Set(imageList)]
    let imgStr = imageList.join(',')
    if (imgStr)
        getFileUrl({ attachments: imgStr }).then(resp => {
            if (resp) {
                fileList.value = resp.payload
                // console.log(fileList.value);
            }
        })

},)

watch(currentPage, () => {
    getDataList();
})

watch(searchInfo, () => {
    currentPage.value = 1;
    getDataList();
}, { deep: true })

onMounted(() => {
    // checkCharts();
    getDataList();
})
//弹出
defineExpose({
    searchInfo,
    getDataList,
    tableInfo,
    loading
})
</script>

<template>
    <div class="form px-0  bg-white" v-if="tableInfo.length || loading" style="height: 100%;border-radius: 0.25rem;">
        <!-- Bordered Tables -->
        <!-- <div style="height:calc(100% - 60px - 1rem); overflow-y: auto;" class="my-scroll-bar"> -->
        <div style="overflow-x: auto; width: 100%; overflow-y: auto;height:calc(100% - 50px);" class="my-scroll-bar">
            <table class="table table-bordered table-nowrap mb-0 " v-loading="loading">
                <thead class="table-light ">
                    <tr>
                        <th scope="col" style="color: #9599AD;" width="30">#</th>
                        <th scope="col" v-for="(head, index) in table_head" :key="index" style="color: #9599AD;"
                            :width="head.width">
                            <div class="d-flex align-items-center" style="height: 36px;">
                                {{ head.label }}
                                <div class="sortable mx-2 cursor-pointer desc" v-if="head.sortable"
                                    style="position: relative; width: 14px; height: 10px;" @click="sort"></div>
                            </div>
                        </th>
                        <th><input @change="toggletAll" v-model="checkedAll" class="form-check-input" type="checkbox"
                                aria-label="Checkbox for following text input"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                        <!-- <td style="text-align: left;">{{ index + 1 }}</td> -->
                        <td>
                            <input
                                v-show="searchInfo.hand.length || searchInfo.skin.length || searchInfo.heat.length || searchInfo.aesthetic_comfort.length"
                                @change="changCheckBox(info.id)" class="form-check-input mt-0" type="checkbox"
                                v-model="info.checked" aria-label="Checkbox for following text input">
                        </td>
                        <td>
                            <a @click="goDetail(info)">
                                <div class="d-flex cursor-pointer">
                                    <div class="avatar-sm bg-light rounded p-1 me-3">
                                        <!-- <img src="assets/images/products/img-1.png" alt="" class="img-fluid d-block"> -->
                                        <img style="width: 40px; height: 40px;"
                                            :src="info['picture'].length && fileList.length ? fileList.filter(item => item.id === info['picture'][0]).length ? fileList.filter(item => item.id === info['picture'][0])[0].url : '' : ''">
                                    </div>
                                    <div class="flex-1 me-2">
                                        <div :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                                            style="font-weight: 500; font-size: 14px; font-family: Poppins; margin-bottom: 0.2rem; max-width: 200px;white-space: normal;">
                                            {{
                                                getName(info['name']) }}</div>
                                        <div style="color: rgba(149, 153, 173, 1);">HS Code：{{
                                            i18n.global.locale == 'en' ? info.hscode?.title_en : info.hscode?.title }}
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </td>
                        <td :class="'zh-word-break'" style="width: 200px; white-space: normal;">{{ i18n.global.locale ==
                            'en' ? info.production_line?.production_line_name_en :
                            info.production_line?.production_line_name
                            }}</td>
                        <td :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                            style="max-width: 150px; white-space: normal;">{{ getPublic(info.public_type) }}</td>
                        <td>{{ getStatus(info.status, info.public_type) }}</td>
                        <td>{{ info['color'] }}</td>
                        <td>{{ info['inventory'] }}</td>
                        <td>
                            <span style="margin-right: 1px;">{{ info['price_unit'] }}</span>
                            {{ info['price'] }}
                        </td>
                        <td>{{ info['type'] }}</td>
                        <td>{{ info['size'] }}</td>
                        <td>
                            <!-- {{ info['pid'] }} -->
                            <img class="cursor-pointer" :src="info.qrcodeImgUrl" v-if="info.qrcodeImgUrl"
                                style="width: 40px;" @click="showImageCode(info.qrcodeImgUrl)" />
                        </td>
                        <td>
                            <template class="d-flex align-items-center">
                                <div class="dropdown"
                                    style="background-color: rgba(53, 119, 241, 0.098); text-align: center; width: 30px; height: 30px; line-height: 30px;">
                                    <a style="display: block; width: 100%; height: 100%;" href="#" role="button"
                                        id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"><i
                                            class="ri-more-line"></i></a>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        <li v-permit="'product-management.show'">
                                            <div class="dropdown-item cursor d-flex align-items-center"
                                                @click="handler('view', info)">
                                                <i class="fs-16 ri-eye-fill text-primary me-2"></i> {{
                                                    getLangValue("base.to_view") }}
                                            </div>
                                        </li>
                                        <!-- 如果是自己的产品放开修改 -->
                                        <li v-if="info.flag !== 1 || info?.organization?.username === username">
                                            <div v-permit="'product-management.modify'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click="handler('edit', info)">
                                                <i class="fs-16 ri-pencil-fill text-primary me-2"></i> {{
                                                    getLangValue("base.edit") }}
                                            </div>
                                        </li>
                                        <li v-if="info.flag !== 1">
                                            <div v-permit="'product-management.copy'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click="handler('copy', info)">
                                                <i class="fs-16 bx bx-copy text-primary me-2"
                                                    style="transform: rotate(90deg); color:black"></i>{{
                                                        getLangValue("base.copy")
                                                    }}
                                            </div>
                                        </li>
                                        <li class="dropdown-divider" v-permit="'product-management.delete'"></li>
                                        <li>
                                            <div v-permit="'product-management.delete'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click="handler('delete', info)">
                                                <i class="fs-16 ri-delete-bin-5-fill text-danger me-2"></i>{{
                                                    getLangValue("base.delete") }}
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                                <i v-if="info.flag === 1" class="ri-indeterminate-circle-line ms-2"
                                    style="font-size: 30px;color: #ED4014;"></i>
                            </template>
                        </td>
                        <td>
                            <input v-if="info.public_type == 2 && info.status == 2 && info.flag != 1"
                                v-model="info.checked1" class="form-check-input" type="checkbox"
                                aria-label="Checkbox for following text input">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 分页 -->
        <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
            :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5"
            style="margin-top: 0 !important;border-radius: 0.25rem;">
        </Pagination>
    </div>
    <div style="height: 100%;" v-else class="d-flex align-items-center justify-content-center">
        <Empty style="margin-top: 200px;"></Empty>
    </div>

    <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
    </PreviewImg>
    <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
</template>
<style scoped>
.table-bordered> :not(caption)>*>* {
    border: unset;
}

.table-bordered td {
    padding: 0.35rem 0.6rem !important;
}

.table-bordered th {
    padding: 0.5rem 0.6rem !important;
}
.sortActive {
    color: black;
}
.sortable {
    &::after {
        content: "\f035d";
        position: absolute;
        right: .5rem;
        top: 0px;
        font-size: .8rem;
        font-family: "Material Design Icons";
    }

    &::before {
        content: "\f0360";
        position: absolute;
        right: .5rem;
        top: -8px;
        font-size: .8rem;
        font-family: "Material Design Icons";
    }
}
.desc {
    &::after {
        color: black;
    }
}

.asc {
    &::before {
        color: black;
    }
}
</style>
